import { ENV_ANDROID, env, getStatusBarHeight } from '@bcz/fe-interface'

export { routerBaseName as ROUTER_BASE_NAME } from '@/../package.json'

/**
 * 百词斩 APP 下载链接（应用宝）
 */
export const BCZ_DOWNLOAD_LINK =
  'https://a.app.qq.com/o/simple.jsp?pkgname=com.jiongji.andriod.card'

export const minHeight = env === ENV_ANDROID ? getStatusBarHeight() : 0
